import { hasPermission } from "@/router/protected-routes"
import type { RouteRecordRaw } from "vue-router"

const agentsRoutes: RouteRecordRaw[] = [
  {
    path: "",
    name: "agentsList",
    component: () => import("@/templates/agents/AgentsList.vue")
  },
  {
    path: "deploy",
    name: "agentCreate",
    component: () => import("@/templates/agents/DeployAgent.vue"),
    meta: { breadcrumb: "agents.deployAgent" },
    beforeEnter: () => {
      return hasPermission("/api/v1/agent", "post")
    }
  }
]

export default agentsRoutes
